export default __webpack_public_path__ + "static/media/local.0b8f444c.jpeg";